import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ErrorBoundary } from './render/ErrorBoundary';

const container = document.getElementById('root');
if (!container) throw new Error('#root missing from index.html');

createRoot(container).render(
  <StrictMode>
    {/* Outside `App`, so a fault in the very first render still has somewhere to
        be reported — and so the boundary's own window listeners are installed
        before anything else has had a chance to throw. */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
